"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@ionic/react");
const mockController_1 = require("./mockController");
const mockIonCheckbox_1 = require("./mockIonCheckbox");
function mockIonicReact() {
    jest.mock('@ionic/react', () => {
        const rest = jest.requireActual('@ionic/react');
        return Object.assign(Object.assign({}, rest), { IonActionSheet: mockController_1.mockController, IonAlert: mockController_1.mockController, IonCheckbox: mockIonCheckbox_1.mockIonCheckbox, IonDatetime: react_1.IonInput, IonLoading: mockController_1.mockController, IonPicker: mockController_1.mockController, IonPopover: mockController_1.mockController, IonToast: mockController_1.mockController, IonModal: mockController_1.mockController, IonToggle: mockIonCheckbox_1.mockIonCheckbox });
    });
}
exports.mockIonicReact = mockIonicReact;
//# sourceMappingURL=mockIonicReact.js.map